import { FmProfileDataOutputTable } from "../FmProfileDataOutputTable";
import { Checkbox, DataSource, Label, Layout, Panel, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutFreightMatchingProfile extends Layout {
    checkboxAutoDispatch: Checkbox;
    checkboxBookingNotifyCarrier: Checkbox;
    checkboxBookingNotifyDispatcher: Checkbox;
    checkboxBookingNotifyEntered: Checkbox;
    checkboxBookingNotifyOperations: Checkbox;
    checkboxBookingNotifyRevCode: Checkbox;
    checkboxBookingNotifySales: Checkbox;
    checkboxCanRetrieveOfferStatus: Checkbox;
    checkboxCanSendEquipPrefs: Checkbox;
    checkboxCanSendLanePrefs: Checkbox;
    checkboxCancelAvailableTractors: Checkbox;
    checkboxClearPayInfo: Checkbox;
    checkboxCreateAvailableTractors: Checkbox;
    checkboxCreateAvailableTractorsOffer: Checkbox;
    checkboxEnableBookingEmail: Checkbox;
    checkboxEnableCarrierDriver: Checkbox;
    checkboxEnableCarrierEquipment: Checkbox;
    checkboxEnableCarrierOffer: Checkbox;
    checkboxEnableComment: Checkbox;
    checkboxEnableLoadBooking: Checkbox;
    checkboxEnableMilestones: Checkbox;
    checkboxEnableResponsibility: Checkbox;
    checkboxEnableSettlementStatus: Checkbox;
    checkboxEnableUnassignmentEmail: Checkbox;
    checkboxEnabledCarrierUnassign: Checkbox;
    checkboxExcludeCustomerFilter: Checkbox;
    checkboxExcludeLockedMovements: Checkbox;
    checkboxExcludeOrderType: Checkbox;
    checkboxExcludeOrdersOnHold: Checkbox;
    checkboxExcludeRevcodeFilter: Checkbox;
    checkboxExcludeStatusFilter: Checkbox;
    checkboxIncludeProhibited: Checkbox;
    checkboxIsPayRateProvider: Checkbox;
    checkboxNotifyArcFailure: Checkbox;
    checkboxNotifyOnBookFailure: Checkbox;
    checkboxNotifyOnOfferFailure: Checkbox;
    checkboxOfferNotifyCarrier: Checkbox;
    checkboxOfferNotifyDispatcher: Checkbox;
    checkboxOfferNotifyEnabled: Checkbox;
    checkboxOfferNotifyEntered: Checkbox;
    checkboxOfferNotifyOperations: Checkbox;
    checkboxOfferNotifyRevCode: Checkbox;
    checkboxOfferNotifySales: Checkbox;
    checkboxOverridePayAmt: Checkbox;
    checkboxReceiveCcArc: Checkbox;
    checkboxRetrieveAvailableTractors: Checkbox;
    checkboxSendArc: Checkbox;
    checkboxUpdateScheduledCallTime: Checkbox;
    checkboxUseDfmEta: Checkbox;
    labelBookingUserRoles: Label;
    labelLoadDetailsAlerts: Label;
    labelLoadWindow: Label;
    labelNotifications: Label;
    labelOfferNotifications: Label;
    labelOfferRecipients: Label;
    labelOfferUserRoles: Label;
    labelRecipients: Label;
    labelToday: Label;
    layoutCarrierDataOutput: FmProfileDataOutputTable;
    layoutLoadDataOutput: FmProfileDataOutputTable;
    layoutSettlementDataOutput: FmProfileDataOutputTable;
    panelBookingNotifications: Panel;
    panelBookingUserRoles: Panel;
    panelBrkStatus: Panel;
    panelCustomer: Panel;
    panelOfferNotifications: Panel;
    panelOfferUserRoles: Panel;
    panelOrderType: Panel;
    panelRevCode: Panel;
    sourceFreightMatchingDataOutputCarrier: DataSource;
    sourceFreightMatchingDataOutputLoad: DataSource;
    sourceFreightMatchingDataOutputSettlement: DataSource;
    sourceFreightMatchingProfile: DataSource;
    tabCarrierBooking: Tab;
    tabCarriers: Tab;
    tabDataOutput: Tab;
    tabGeneral: Tab;
    tabLoadBooking: Tab;
    tabLoads: Tab;
    tabSettlements: Tab;
    tabVisibility: Tab;
    tabsetDataOutput: Tabset;
    tabsetFreightMatching: Tabset;
    textboxAutoRateConfirmTemplate: Textbox;
    textboxBrkQualProfOverride: Textbox;
    textboxBrokerageCode: Textbox;
    textboxBrokerageStatusFilter: Textbox;
    textboxCarrierOfferFilter: Textbox;
    textboxCarrierQualStatus: Textbox;
    textboxCarrierReturnLimit: Textbox;
    textboxCarrierStatus: Textbox;
    textboxCommentType: Textbox;
    textboxCustomerFilter: Textbox;
    textboxDaysAfter: Textbox;
    textboxDaysPrior: Textbox;
    textboxDescr: Textbox;
    textboxId: Textbox;
    textboxIncludedContacts: Textbox;
    textboxIncludedLoadboardValue: Textbox;
    textboxLoadReturnLimit: Textbox;
    textboxMovementStatus: Textbox;
    textboxNotifyBookingGroups: Textbox;
    textboxNotifyBookingUsers: Textbox;
    textboxOfferCarrierWarning: Textbox;
    textboxOfferFailReasons: Textbox;
    textboxOfferMaxPayOverride: Textbox;
    textboxOfferNotifyEmails: Textbox;
    textboxOfferNotifyGroups: Textbox;
    textboxOfferNotifyUsers: Textbox;
    textboxOrderModeFilter: Textbox;
    textboxOrderTypeFilter: Textbox;
    textboxOtherBookingEmails: Textbox;
    textboxPostedType: Textbox;
    textboxRateConfirmationFrom: Textbox;
    textboxRevcodeFilter: Textbox;
    textboxTractorBrokerageCode: Textbox;
}
